import React, { forwardRef } from "react";
import classNames from "classnames";

export default Component => forwardRef(({ isFetching, ...restProps }, ref) =>
  <Component {...restProps} isFetching={isFetching} ref={ref} className={classNames({ "loading-container": isFetching })} />);
